import { render, staticRenderFns } from "./SendEmailDialog.vue?vue&type=template&id=210a521a&scoped=true"
import script from "./SendEmailDialog.vue?vue&type=script&lang=js"
export * from "./SendEmailDialog.vue?vue&type=script&lang=js"
import style0 from "./SendEmailDialog.vue?vue&type=style&index=0&id=210a521a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210a521a",
  null
  
)

export default component.exports